import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, CircularProgress, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import useUnitStore from '../store/useUnitStore';
import useNotificationStore from '../store/useNotificationStore';
import MwcTable from './MwcTable';
import MwcForm from './MwcForm';

const MwcManagement = () => {
  const { mwcUnits, loading, error, fetchMwc, addMwc, updateMwc, removeMwc } = useUnitStore();
  const showNotification = useNotificationStore((state) => state.showNotification);

  const [openForm, setOpenForm] = useState(false);
  const [selectedMwc, setSelectedMwc] = useState(null);

  useEffect(() => {
    fetchMwc();
  }, [fetchMwc]);

  const handleOpenAddForm = () => {
    setSelectedMwc(null);
    setOpenForm(true);
  };

  const handleOpenEditForm = (mwc) => {
    setSelectedMwc(mwc);
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setSelectedMwc(null);
  };

  const handleSaveMwc = async (data) => {
    try {
      if (selectedMwc) {
        await updateMwc(selectedMwc.id, data);
        showNotification('Unit MWC berhasil diperbarui', 'success');
      } else {
        await addMwc(data);
        showNotification('Unit MWC berhasil ditambahkan', 'success');
      }
      handleCloseForm();
    } catch (err) {
      showNotification(`Gagal menyimpan MWC: ${err.message}`, 'error');
    }
  };

  const handleDeleteMwc = async (id) => {
    if (window.confirm('Apakah Anda yakin ingin menghapus unit MWC ini? Ini akan menghapus semua Ranting dan Pengguna terkait.')) {
      try {
        await removeMwc(id);
        showNotification('Unit MWC berhasil dihapus', 'success');
      } catch (err) {
        showNotification(`Gagal menghapus MWC: ${err.message}`, 'error');
      }
    }
  };

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error: {error}</Alert>;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Daftar MWC</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpenAddForm}>Tambah MWC</Button>
      </Box>
      <MwcTable mwcUnits={mwcUnits} onEdit={handleOpenEditForm} onDelete={handleDeleteMwc} />

      <Dialog open={openForm} onClose={handleCloseForm} fullWidth maxWidth="sm">
        <DialogTitle>{selectedMwc ? 'Edit MWC' : 'Tambah MWC'}</DialogTitle>
        <DialogContent>
          <MwcForm initialData={selectedMwc} onSave={handleSaveMwc} onCancel={handleCloseForm} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default MwcManagement;
